import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { BudgetLine, BudgetLineCreate, BudgetLineFilter } from '../data/budgetLine';

export function createBudgetLineService(client: AxiosInstance) {
  return createCrudService<BudgetLine, BudgetLineCreate, BudgetLineFilter>(
    client,
    '/accounting/BudgetLine',
    'id',
  );
}

export type BudgetLineService = CrudService<BudgetLine, BudgetLineCreate, BudgetLineFilter>;
